<template>
    <div class="footer-box">
        <el-row>
            <!--      <el-col :xs="0" :sm="2" :md="7" :lg="7" :xl="10">-->
            <!--        -->
            <!--      </el-col>-->
            <el-col :xs="0" :span="22" :offset="1">
                <table class="foot-table" border="0">
                    <tr class="foot-table-T">
                        <td>走进索康</td>
                        <td>产品专区</td>
                        <td>技术荣誉</td>
<!--                        <td>美例说</td>-->
                        <td>防伪查询</td>
                    </tr>
                    <tr>
                        <td>
                            <router-link :to="{path:'/enterprise',query:{id:'en-into-corporate'}}">企业介绍</router-link>
                        </td>
                        <td>
                            <router-link :to="{path:'/product/manshu'}">曼姝</router-link>
                        </td>
                        <td>
                            <router-link :to="{path:'/honor',query:{id:'honorPatentTechnology'}}">技术 & 专利</router-link>
                        </td>
<!--                        <td><router-link :to="{path:'/case'}">案例</router-link></td>-->
                        <td><router-link :to="{path:'/security/QA'}">质保卡流程</router-link></td>
                    </tr>
                    <tr>
                        <td>
                            <router-link :to="{path:'/enterprise',query:{id:'en-corporate-history'}}">企业历史</router-link>
                        </td>
                        <td>
                            <router-link :to="{path:'/product/lixiu'}">立秀</router-link>
                        </td>
                        <td>
                            <router-link :to="{path:'/honor',query:{id:'honorCertificate'}}">专利证书</router-link>
                        </td>
<!--                        <td></td>-->
                        <td><router-link :to="{path:'/security/authenticity'}">真伪查询</router-link></td>
                    </tr>
                    <tr>
                        <td>
                            <router-link :to="{path:'/enterprise',query:{id:'en-corporate-culture'}}">企业文化</router-link>
                        </td>
                        <td>
                            <router-link :to="{path:'/product/ainose'}">AINOSE</router-link>
                        </td>
                        <td><router-link :to="{path:'/honor',query:{id:'honorQualifications'}}">资质 & 荣誉</router-link></td>
                        <td></td>
<!--                        <td><router-link :to="{path:'/contact'}">联系我们</router-link></td>-->
                    </tr>
                    <tr>
                        <td>
                            <router-link :to="{path:'/enterprise',query:{id:'en-material-history'}}">膨体历史</router-link>
                        </td>
                        <td>
                            <router-link :to="{path:'/product/hetong'}">郝通</router-link>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <router-link :to="{path:'/enterprise',query:{id:'en-production'}}">生产与研发</router-link>
                        </td>
                        <td>
                            <router-link :to="{path:'/product/meiti'}">美替</router-link>
                        </td>
                    </tr>
                </table>
            </el-col>
            <el-col :xs="0" :span="18" :offset="3">
                <div class="footer-partition"></div>
            </el-col>
            <el-col type="flex" justify="space-between" :xs="{span:22,offset:1}" :sm="{span:18,offset:3}"
                    :md="{span:18,offset:3}" :lg="{span:18,offset:3}" :xl="{span:18,offset:3}">
                <div class="footer-boxs">
                    <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
                        <div class="footer-text">
                            <div class="footer-text-T">上海索康医用材料有限公司</div>
                            <p>Add：上海市绥德路613弄2号楼</p>
                            <p>Tel：（86）- 21 - 66082766  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fax：（86）- 21 - 66082138 </p>
                        </div>
                    </el-col>
                    <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
                        <div class="footer-text">
<!--                            <a class="footer-text-T">京公网安备 11010802017518 </a>-->
                            <a class="footer-text-T footer-keep-on-record" href="http://www.beian.miit.gov.cn">沪ICP备 15041776号</a>
                        </div>
                    </el-col>
<!--                    <el-col type="flex" align="middle" :xs="6" :sm="6" :md="6" :lg="6" :xl="6">-->
<!--                        <el-col :span="12">-->
<!--                            <div class="foot-img-div">-->
<!--                                <img class="foot-img" src="../../../static/image/main/mainWX1.png">-->
<!--                                <div class="foot-img-text">关注微信</div>-->
<!--                            </div>-->
<!--                        </el-col>-->
<!--                        <el-col :span="12">-->
<!--                            <div class="foot-img-div">-->
<!--                                <img class="foot-img" src="../../../static/image/main/mainWX02.png">-->
<!--                                <div class="foot-img-text">关注微博</div>-->
<!--                            </div>-->
<!--                        </el-col>-->
<!--                    </el-col>-->
                </div>
            </el-col>

        </el-row>
    </div>
</template>

<script>
export default {
  name: 'Footer',
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0)
    })
  }
}
</script>

<style scoped>
    a {
        text-decoration: none;
        color: #a3a3a3;
    }

    .router-link-active {
        text-decoration: none;
        color: #a3a3a3;
    }

    .footer-box {
        background-color: #191919;
        padding: 50px 0;
    }

    .foot-table {
        width: 100%;
        text-align: center;
        font-size: 18px;
        font-family: SY-Light;
        color: #a3a3a3;
        height: 280px;
    }

    foot-table > td {
        width: 20%;
    }

    .foot-table-T {
        color: white;
        font-size: 20px;
    }

    .footer-partition {
        border-bottom: 2px solid #ababab;
        margin-top: 4%;
    }

    .footer-text {
        font-family: SY-Light;
        font-size: 18px;
        color: #ffffff;
        /*margin: 10% 0 5% 0;*/
    }

    .footer-text > p {
        margin: 1% 0;
    }

    .footer-text-T {
        font-size: 20px;
        margin-bottom: 3%;
        font-family: SY-Normal;
    }

    .foot-img {
        width: 100%;
    }

    .foot-img-div{
        margin: 10px;
    }

    .foot-img-text {
        font-family: SY-Light;
        color: white;
        font-size: 16px;
        text-align: center;
    }

    .footer-boxs {
        height: 200px;
        padding: 40px 0;
    }
</style>
